import {
  Dialog,
  DialogButtons,
  DialogContent,
  DialogMessageBox,
  DialogTitle,
} from '@verantos-dev/shared-components';

import { useAdSaveModal } from '../hooks/useAdSaveModal';
import type { AdSaveModalProps } from '../types';

const DIALOG_PAPER_SX = { width: 600, maxHeight: '80%', margin: 0 } as const;

export const AdSaveModal = ({ onClose }: AdSaveModalProps) => {
  const {
    title,
    loadingTitle,
    loadingText,
    errorTitle,
    errorText,
    retryButtonLabel,
    isSubmitting,
    submittingError,
    onRetry,
  } = useAdSaveModal({ onClose });

  // While the save round-trip is in flight there is no exit affordance — the
  // user shouldn't be able to dismiss the dialog mid-flight (the BE write
  // would still land but the UI would lose the success/navigation handoff).
  // The error state restores the close affordance so the user can give up.
  const inError = !!submittingError && !isSubmitting;

  return (
    <Dialog
      id="adSaveModal"
      open
      PaperProps={{ sx: DIALOG_PAPER_SX }}
      fullWidth
      maxWidth="lg"
      onClose={inError ? onClose : undefined}
    >
      <DialogTitle
        id="ad-save-modal-title"
        showClose={inError}
        onClose={inError ? onClose : undefined}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        {inError ? (
          <DialogMessageBox
            id="ad-save-modal-error"
            title={errorTitle}
            type="error"
            text={errorText}
          />
        ) : (
          <DialogMessageBox
            id="ad-save-modal-loading"
            title={loadingTitle}
            type="loading"
            text={loadingText}
          />
        )}
      </DialogContent>
      {inError && (
        <DialogButtons
          id="ad-save-modal-buttons"
          saveButton={{ label: retryButtonLabel, onClick: onRetry }}
        />
      )}
    </Dialog>
  );
};
